import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { SessionService } from '../providers/session.service';
import { SmsApiSessionService } from '../providers/sms-api-session.service';
import { AgreementService } from '../providers/agreement.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private sessionService: SessionService,
        private smsApiSessionService: SmsApiSessionService,
        private agreementService: AgreementService,
    ) {}

    canActivate(): Promise<boolean> {
        return this.smsApiSessionService.getSession().then(user => {
            if (!user.enabled) {
                this.router.navigate(['login']);
                return false;
            }

            this.sessionService.setUser(user);

            return this.agreementService.checkAssentStatus().then(status => {
                if (!status.all_current) {
                    this.router.navigate(['review-agreements']);
                    return false;
                }
                return true;
            }).catch(() => {
                // If we can't reach the agreement endpoint treat the session as
                // valid and let the user through — don't lock them out over a
                // transient network error.
                return true;
            });

        }).catch(error => {
            console.log(error);
            this.router.navigate(['login']);
            return false;
        });
    }
}
